import React from 'react'
import { StyledBanners } from './styled'
import { BannersProps } from './types'
import Friend from 'images/top/banners/friend.png'
import Remote from 'images/top/banners/remote.png'
import Benefit from 'images/top/banners/benefit.png'
import Knowledge from 'images/top/banners/knowledge.png'
import DxBoost from 'images/top/banners/dx_boost.png'

export const BannerImages = [
  { src: Friend, alt: 'ご友人紹介特典', href: '/referral', id: 'ga-footer-bnr-friend' },
  { src: Remote, alt: 'リモートワーク特集', href: '/job_offers/remote', id: 'ga-footer-bnr-remote' },
  { src: Benefit, alt: '会員限定特典', href: '/benefit', id: 'ga-footer-bnr-benefit'},
  { src: Knowledge, alt: 'ビギナー向けフリーランスの基礎知識', href: '/knowledge', id: 'ga-footer-bnr-knowledge' },
  { src: DxBoost, alt: 'DX領域特化型フリーランスエージェント', href: 'https://dx-pro.net/boost_freelance/', id: 'ga-footer-bnr-peaceful-morning' },
]

export const Banners: React.FC<BannersProps> = ({ className }) => {
  return <StyledBanners banners={BannerImages} className={className} />
}
